export default __webpack_public_path__ + "static/media/DSC_7339.95f7018c.jpg";